"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = exports.handleColor = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var classNames = require("classnames");
var handleColor = function (props) {
    var percent = (function () {
        if (props.percent < 0) {
            return 0;
        }
        else if (props.percent > 100) {
            return 100;
        }
        return props.percent;
    })();
    var color = (function () {
        if (percent <= 10) {
            return 'dark-yellow';
        }
        else if (percent > 10 && percent <= 40) {
            return 'cyan';
        }
        else if (percent > 40 && percent <= 80) {
            return 'spring-green';
        }
        return 'base-green';
    })();
    var labelText = (function () {
        if (percent < 100) {
            return "".concat(percent, " %");
        }
        return props.doneText;
    })();
    return __assign(__assign({}, props), { percent: percent, color: color, labelText: labelText });
};
exports.handleColor = handleColor;
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('ProgressBar'), (0, recompose_1.defaultProps)({
    percent: 0,
    compact: false,
    showLabel: true,
    doneText: 'Done!'
}), (0, recompose_1.mapProps)(exports.handleColor), recompose_1.pure);
exports.ProgressBar = enhance(function (props) { return (React.createElement("div", { className: classNames('sok-progressbar', props.compact && 'compact', props.showLabel && 'show-label') },
    React.createElement("div", { className: classNames('sok-progressbar-process', props.color), style: { width: props.percent + '%' } }),
    props.showLabel &&
        props.percent > 0 && (React.createElement("span", { className: 'sok-progressbar-label', style: { left: "".concat(props.percent, "%") } }, props.labelText)))); });
//# sourceMappingURL=index.js.map